const removeLayers = (layers, partialLayerId) => {
    return layers.filter(({ id }) => {
        return !id.includes(partialLayerId);
    });
};

export default removeLayers;
